<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Sửa"
             type="orange"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.key" form-group-class="col-md-6 col-sm-6" label="Key"
               validate-rules="required"/>
      <c-input v-model.trim="model.value" form-group-class="col-md-6 col-sm-6" label="Value"
               validate-rules="required"/>
      <c-input v-model.trim="model.type" form-group-class="col-md-6 col-sm-6" label="Type"
               validate-rules="required"/>
      <c-select2 v-model="model.isActive"
                 label="Đang hoạt động"
                 form-group-class="col-md-6 col-sm-6"
                 validate-rules="required"
      >
        <option value="true">true</option>
        <option value="false">false</option>
      </c-select2>
      <c-input v-model.trim="model.description" form-group-class="col-md-12 col-sm-12" label="Description"/>

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        id : null,
        key: null,
        value: null,
        type: null,
        description: null,
        isActive: null
      },
    }
  },
  methods: {
    open(type,key) {
      this.show = true;
      this.model = {
        key: null,
        value: null,
        type: null,
        description: null,
        isActive: null
      }
      this.getData(type,key);
    },
    getData(type,key) {
      this.$adminService
      .get(`/v1.0/config/system-config?config_type=${type}&config_key=${key}`)
      .then(successRes => {
        let data = successRes.data.data;
        this.model.id = data.id;
        this.model.key = data.key;
        this.model.value = data.value;
        this.model.type = data.type;
        this.model.description = data.description;
        this.model.isActive = data.status ? "true" : "false";
        console.log(data);
      }, errorRes => {
        this.errorNotify(errorRes)
        .then(errorRes => this.$cmsBadRequest(errorRes));
        this.$stopLoader();
      });
    },
    submit() {
      this.$showLoader();
      let status = this.model.isActive === "true" ? 1 : 0;
      let data = {
        "key": this.model.key,
        "value": this.model.value,
        "type": this.model.type,
        "description" : this.model.description,
        "status" : status
      }
      this.$adminService
      .post(`/v1.0/config/system-config`, data)
      .then(successRes => {
        this.close();
        this.$success();
        this.$stopLoader();

        this.$emit("success", successRes);
      }, errorRes => {
        this.$stopLoader();
        this.errorNotify(errorRes)
        .then(errorRes => this.$cmsBadRequest(errorRes));
        this.$emit("error", errorRes);
      })
      ;
    }
  }
}
</script>

<style scoped>

</style>